
const isValidEmail = email => {
  return  /(.+)@(.+){2,}\.(.+){2,}/.test(email);
}


const submitForm = data => {
  return new Promise((resolve, reject) => {
    const request = new XMLHttpRequest();
    request.open('POST', loadmore_params.ajaxurl, true);
    request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    // request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

    request.onload = function() {
      if (this.status >= 200 && this.status < 400) {
        if (this.response) {
          resolve(this.response);
        }

      } else {
        reject(this.response);
      }
    };

    request.onerror = function() {
      reject(this.response);
    };

    request.send(data);
  });
}

export default class FormMailchimp {
  constructor() {
    this.selector = '.c-form-mailchimp';
  }

  bootstrap() {
    document.querySelectorAll(this.selector).forEach( component => {
      const form = component.querySelector('.c-form-mailchimp__form');
      const emailField = component.querySelector('.c-form-mailchimp__form input[name="email_address"]');
      const fieldMessage = component.querySelector('.c-form-mailchimp__field-message')
      const formSuccessMessage = component.querySelector('.c-form-mailchimp__message--success')
      const formErrorMessage = component.querySelector('.c-form-mailchimp__message--error')
      const button = component.querySelector('.c-form-mailchimp__btn--submit')

      // on submit
      form.addEventListener('submit', event => {
        event.preventDefault();
        // clean
        this.cleanFieldError(emailField);
        formSuccessMessage.innerText = '';
        component.classList.remove('c-form-mailchimp--success');

        component.classList.add('c-form-mailchimp--loading');
        button.disabled = true;


        // check for simple email validation
        if ( !isValidEmail ( emailField.value )) {
          // set error message
          this.setFieldError(emailField, 'Please enter valid email address');
        } else {
          // email is valid
          // do a ajax request
          const formData = new FormData(form);
          // var formData = new FormData();
          submitForm(formData).then(data => {
            data = JSON.parse(data);

            if (data.status === 'success') {
              component.classList.remove('c-form-mailchimp--error');
              component.classList.add('c-form-mailchimp--success');
              formSuccessMessage.innerText = data.message;
            } else {
              component.classList.remove('c-form-mailchimp--success');
              component.classList.add('c-form-mailchimp--error');
              formErrorMessage.innerText = data.message;
            }

            component.classList.remove('c-form-mailchimp--loading');
            button.disabled = false;

          }).catch(error => {
            console.log('error on submit form', error);
            component.classList.add('c-form-mailchimp--error');
            formErrorMessage.innerText = 'There was server error, please try again';

            component.classList.remove('c-form-mailchimp--loading');
            button.disabled = false;
          });
        }
      })
    });
  }


  cleanFieldError(field) {
    const parent = field.parentNode;
    const fieldMessage = parent.querySelector('.c-form-mailchimp__field-message');
    fieldMessage.innerText = '';
    fieldMessage.style.display = 'none';
    fieldMessage.classList.remove('c-form-mailchimp__field-message--error');
  }

  setFieldError(field, message) {
    const parent = field.parentNode;
    const fieldMessage = parent.querySelector('.c-form-mailchimp__field-message');
    fieldMessage.classList.add('c-form-mailchimp__field-message--error');
    fieldMessage.innerText = message;
    fieldMessage.style.display = 'block';
  }
}

